import { ActionIcon, Tooltip } from '@mantine/core';
import { variants } from '@uag/react-core';
import { t } from 'i18next';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface ArticleToolsProps {
    menuOpened: boolean;
}

const screenWidth = window.screen.width; 

export const ArticleTools = ({ menuOpened }: ArticleToolsProps) => {
    const { articleInstanceSelectionsCount, updatePivotControls } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelectionsCount: Object.keys(state.articleInstanceSelections).length,
            updatePivotControls: state.updatePivotControls,
        }))
    );

    return (
        <Tooltip disabled={menuOpened} label={t('transform')} position="right" variant={variants.tooltip.right}>
            <ActionIcon 
                className={`
                    bg-background-gray-ultra-light hover:bg-background-gray! pointer-events-auto
                    ${screenWidth >=1920 ? 'action-icon-large' : 'action-icon-medium'}
                `}
                opacity={articleInstanceSelectionsCount >= 1 ? 1 : 0.6}
                style={{ cursor: articleInstanceSelectionsCount >= 1 ? 'pointer' : 'not-allowed' }}
                onPointerDown={updatePivotControls}
            >
                transform
            </ActionIcon>
        </Tooltip>
    );
};